export const getCorrectedDigits = (text) => {
    const fixedText = text.toString().replace(/[^0-9]+/, '')

    return (fixedText === '' ? 0 : parseInt(fixedText))
}